// extracted by mini-css-extract-plugin
export default {"warning":"FIucaIZV05vojxONM3rX","error":"doGtDlzpFEmACT8iIIT3","neutral":"Yuiw7i4VrLKGM4pfamU_"};